<template>
	<div>
		<post-comment-show
			v-for="(comment, i) in comments"
			:comment="comment"
			:post="post"
			:parent="parent"
			:children="children"
			:user-reaction="comment.my_reaction"
			v-bind:key="'comment-' + i"
			:postDeleted="postDeleted"
		/>
		<template v-if="commentsCount">
			<div
				v-if="children && commentsCount - comments.length > 0"
				class="pl-16 font-weight-bold font-14 post-comments-children-more pt-2 cursor-pointer"
			>
				<v-btn
					:loading="loading.moreAnswers"
					@click="showMoreAnswers()"
					text
					plain
					class="px-0 py-0 grey--text"
					height="auto"
				>
					Wyświetl więcej ({{ commentsCount }} wszystkich) <v-icon class="grey--text">$arrow-down</v-icon>
				</v-btn>
			</div>

			<div v-else-if="!children" class="grey--text text--darken-2 mt-4 d-flex justify-content-between">
				<v-btn v-if="comments.length < commentsCount" @click="showMoreComments()" text plain :loading="loading.moreComments" class="pa-0">
					Zobacz więcej komentarzy
				</v-btn>
				<div class="ml-auto">
					{{ comments.length }} z {{ commentsCount }}
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import PostCommentShow from "@/components/wall/post/PostCommentShow";
import {mapActions} from "vuex";
export default {
	name: "PostCommentList",
	components: {
		PostCommentShow
	},
	props: {
		post: {
			type: Number,
			required: true
		},
		parent: {
			type: Number,
			default: null
		},
		comments: {
			type: Array,
			required: true
		},
		commentsCount: {
			type: Number,
			default: 0
		},
		children: {
			type: Boolean,
			default: false
		},
		postDeleted: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			retrieving: false,
			text: '',
			loading: {
				moreComments: false,
				moreAnswers: false
			}
		}
	},
	created() {
		// this.text = this.$vuetify.lang.t('$vuetify.views.wall.post.comment.loadAnswers', { variable: this.commentsCount })
	},
	methods: {
		...mapActions('wall', [
			'getComments',
			'getAnswers'
		]),
		async showMoreComments() {
			if (this.retrieving)
				return null
			this.retrieving = true
			let id = this.post, root_id = this.parent
			this.loading.moreComments = true;
			await this.getComments({ id, root_id })
			this.loading.moreComments = false;
			this.retrieving = false
		},
		async showMoreAnswers() {
			if (this.retrieving)
				return null
			this.retrieving = true
			let postID = this.post,
				commentID = this.parent

			this.loading.moreAnswers = true;
			await this.getAnswers({ postID, commentID })
			this.loading.moreAnswers = false;
			this.retrieving = false
		}
	}
}
</script>

<style lang="scss">
.post-comments-children-more {
	position: relative;
	&::before {
		position: absolute;
		content: "";
		left: 20px;
		top: -2px;
		width: 30px;
		height: 20px;
		border-left: 1px solid;
		border-bottom: 1px solid;
		border-radius: 0 0 0 10px;
		border-color: var(--v-grey-lighten3);
	}
}
.comments-more {
	cursor: pointer;
	font-weight: bold;
	&:hover {
		color: var(--v-grey-darken1);

	}
}
</style>
